//*****Library*****//
    import React, { useEffect, useContext} from 'react'
    import {BrowserRouter as Router, Switch, Redirect, Route, Routes} from 'react-router-dom'
    //import {initializeIcons} from 'office-ui-fabric-react'
    import { initializeIcons } from '@fluentui/react/lib/Icons';
    import CookiesJS from 'js-cookie';
    import { getSafeCookie } from '../helpers/cookieHelper';
    import { decodeSessionData, cleanSessionFromUrl } from '../helpers/urlSessionHelper';

//*****Components*****//
    import RouterPrivate from '../components/routers/private/privateRouter.component'
    import RouterAdminPrivate from '../components/routers/privateAdmin/privateAdminRouter.component'
    import RouterPublic from '../components/routers/public/publicRouter.component'
    import AvisoError from '../components/containers/containerError/avisoError'
    import ContainerBaseLoading from '../components/containers/baseLoading/containerBaseLoading.component'
//*****Layouts*****//
    import Main from '../layouts/main'
    import NotAuthorization from '../layouts/notAuthorization'
    //**Admin**//
        import Admin from '../layouts/admin/admin'
    //**User**//
        import User from '../layouts/users/user'
    

//*****Context*****//
    import CredentialsState from '../context/credentials/credentrialsState'
    import CredentialsContext from '../context/credentials/credentialsContext'
import FetchOAuth from '../utils/validations/oauth.controller';
import { PATH_APPLICATION, PATH_SSO, SSO_URI } from '../assets/settings/settinsrouters';
import LenguajeState from '../context/Lenguaje/lenguajeState';


/*****************
 *****************
 * @returns copomnent Routers
 *****************
 *****************/

const RouterViews = () => {      
     /************************
     * @arguments 
     ************************/
      const [isValidatingSession, setIsValidatingSession] = React.useState(true);
      const [sessionProcessed, setSessionProcessed] = React.useState(false);
      const token = CookiesJS.get('token')
      const dataUserCookie = getSafeCookie('dataUser');
      const showAdmin = dataUserCookie?.showAdmin || false;
      const dataClient = getSafeCookie('dataClient');
      const client = CookiesJS.get('nameClient')
      const theme = dataClient;
      const style = document.documentElement.style;
      
    /************************
     * @hooks 
     ************************/
      // Inicializar iconos
      useEffect(() => {
        initializeIcons();
      }, [])
      
      // Procesar datos de sesión desde URL (PRIMERO)
      useEffect(() => {
        if (sessionProcessed) return;
        
        // Extraer nameClient de la URL (ej: /bextsa/administration -> "bextsa", también puede ser /Admin/bextsa/administration)
        const pathParts = window.location.pathname.split('/').filter(p => p);
        //const extractedNameClient = pathParts.length > 0 ? pathParts[1] : null;
        const extractedNameClient = (pathParts[0] === PATH_APPLICATION) 
          ? (pathParts[1] || null) 
          : (pathParts[0] || null);
        
        // Guardar nameClient en cookie si se extrajo de la URL
        if (extractedNameClient && extractedNameClient !== 'administration' && extractedNameClient !== 'user') {
          CookiesJS.set('nameClient', extractedNameClient, {sameSite: 'Lax', secure: true});
        }
        
        // Obtener parámetro 'session' de la URL
        const urlParams = new URLSearchParams(window.location.search);
        const sessionParam = urlParams.get('session');
        
        if (sessionParam) {
          const sessionData = decodeSessionData(sessionParam);
          
          if (sessionData) {
            // Guardar datos en cookies
            CookiesJS.set('dataUser', sessionData.dataUser, {sameSite: 'Lax', secure: true});
            CookiesJS.set('dataToken', sessionData.dataToken, {sameSite: 'Lax', secure: true});
            if (sessionData.dataClient) {
              CookiesJS.set('dataClient', sessionData.dataClient, {sameSite: 'Lax', secure: true});
            }
            CookiesJS.set('token', sessionData.token, {sameSite: 'Lax', secure: true});
            if (sessionData.refreshToken) {
              CookiesJS.set('refresh_token', sessionData.refreshToken, {sameSite: 'Lax', secure: true});
            }
            if (sessionData.languages) {
              CookiesJS.set('languages', sessionData.languages, {sameSite: 'Lax', secure: true});
            }
            
            // Limpiar URL (remover parámetros de sesión)
            cleanSessionFromUrl();
            
            // Recargar para que las cookies se apliquen
            setTimeout(() => window.location.reload(), 100);
          }
        }
        
        setSessionProcessed(true);
      }, [sessionProcessed]);
      
      // Validar si las cookies necesarias existen (SEGUNDO - después de procesar URL)
      useEffect(() => {
        if (!sessionProcessed) return;
        
        const timeoutId = setTimeout(() => {
          if (!token || !dataUserCookie || !dataClient) {
            // Obtener la URL del SSO desde runtime-env
            const ssoUri = window.__RUNTIME_CONFIG__?.BSR_SSO_URI || 'http://localhost:3400';
            window.location.href = ssoUri;
          } else {
            setIsValidatingSession(false);
          }
        }, 300);
        
        return () => clearTimeout(timeoutId);
      }, [token, dataUserCookie, dataClient, sessionProcessed]);
      
      // Aplicar tema
      useEffect(() => {
        if(!showAdmin && theme){
          style.setProperty('--background-image', `url(${theme.imageBackgroundPath})`);
          style.setProperty('--color-primary', `#${theme.primaryColor}`);
          style.setProperty('--color-light', `#${theme.ligthColor}`);
          style.setProperty('--color-semilight', `#${theme.semiligthColor}`);
          style.setProperty('--color-semidark', `#${theme.semidarkColor}`);
          style.setProperty('--color-dark', `#${theme.darkColor}`);
          style.setProperty('--color-hover', `#${theme.darkColor}`);
          style.setProperty('--font-primary', `${theme.primaryFont}`);
        }
      }, [showAdmin, theme]);
      
      // Mostrar loading mientras valida sesión
      if (isValidatingSession) {
        return <ContainerBaseLoading />;
      }
      
    /************************
     * @methods 
     ************************/
    
    //  useEffect(async () => {
    //     let isvalid = await FetchOAuth({
    //         accessToken: token,
    //         type: 'introspect',
    //         tenant: client
    //     })
    //     if(isvalid.data.data.data.active == 'false') {
    //         CookiesJS.remove('token')
    //         window.location.href = `${SSO_URI}${client}/home`
    //     }
    // },[window.location.href])
    
    
    /************************
     * @resturns 
     ************************/
        return (
            <CredentialsState>
                <LenguajeState>
                <Router>
                    <Routes>
                        {/* <Route path="/:clientName/" element={<Main />}/> */}
                        <Route path={`${PATH_APPLICATION==''?PATH_APPLICATION:'/'+PATH_APPLICATION}/:clientName/user/*`} element={<User />} />
                        <Route path={`${PATH_APPLICATION==''?PATH_APPLICATION:'/'+PATH_APPLICATION}/:clientName/administration/*`} element={<Admin />} />
                        <Route path="*" element={<AvisoError />} />
                        <Route path={`${PATH_APPLICATION==''?PATH_APPLICATION:'/'+PATH_APPLICATION}/:clientName/NotAuthorization`} element={<NotAuthorization />} />
                    </Routes>
                </Router>
                </LenguajeState>
            </CredentialsState>
        );
}


export default RouterViews;